import Vue from 'vue';
import { apiPath } from '../constants';

const Auth = Vue.resource(
  `${apiPath}/sessions{/type}{/action}/`,
  {},
  {
    login: {
      method: 'POST',
    },
    logout: {
      method: 'DELETE',
      params: { type: 'me' },
      url: '',
    },
    refresh: {
      method: 'PUT',
      params: { type: 'me' },
    },
    verifyOTP: {
      method: 'POST',
      params: { type: 'otp', action: 'verify' },
    },
    verifySMSCode: {
      method: 'POST',
      params: { type: 'sms', action: 'verify' },
    },
    resendSMS: {
      method: 'POST',
      params: { type: 'sms', action: 'resend' },
    },
    userData: {
      method: 'GET',
      url: `${apiPath}/account/user-info/v2/`,
    },
  },
  {
    transformToCamelCase: true,
  },
);

export default Auth;
